<div *ngIf="field.title" class="grid-title">{{field.title}}</div>
<xux-grid
  class="xux-list"
  [ngClass]="gridOptions.treeViewMode ? 'tree-children-item xux-list-white-items' : ''"
  [disabled]="field?.disabledObs | async"
  [items]="selectOptionsObs | async"
  [columns]="columns"
  [view]="gridView"
  [options]="gridOptions"
  [rowButtons]="rowActionButtons"
  [buttons]="actionButtons"
  [userComponents]="xviCustomGridComponents"
  [userGridOptions]="field?.widgetData?.userGridOptions"
  [pinnedTopRowData]="gridOptions?.pinnedTopRowData"
  (action)="onGridAction($event)"
  [i18n]="staticI18nTextContent?.xuxGrid"
>
</xux-grid>
<xux-loader-small
  [background]="'transparent'"
  [cssScale]="0.75"
  [isLoaderVisible]="isPending"
></xux-loader-small>
